export default __webpack_public_path__ + "static/media/nikeW.bcc7aa38.png";